<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          class="ma-2"
          @click="abrirDialogImportacao()"
        >
          <v-icon>mdi-file-import</v-icon>
        </v-btn>
      </template>
      <span>Importar Planilha de Análise</span>
    </v-tooltip>

    <SysDialog
      v-model="ativar_dialog"
      :titulo="TITULO_IMPORTACAO"
      :txtBotao="'carregar'"
      @click:primary="importarDadosTemporarioPlanilha()"
      @click:hidden-dialog="fecharDialogImportacao()"
    >
      <div class="mb-4">
        Baixar modelo: <v-btn color="primary" class="ml-0 pl-0" plain small v-text="'Clique Aqui'" @click="baixarModeloPlanilha()" />
      </div>

      <v-alert
        v-if="message"
        type="error"
        elevation="2"
      >
        <p
          class="ma-0 pa-0"
          v-for="(m, idx) in message"
          :key="idx"
        >
          {{ m }}
        </p>
      </v-alert>

      <SysGrupoAutocomplete
        v-model="form.id_grupo"
        label="Selecione o Grupo"
        outlined
        :error-messages="idGrupoErrors"
        @input="$v.form.id_grupo.$touch()"
        @blur="$v.form.id_grupo.$touch()"
      />

      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="form.data"
            label="Data"
            outlined
            persistent-hint
            prepend-icon=""
            v-bind="attrs"
            v-on="on"
            :error-messages="dataErrors"
            @input="$v.form.data.$touch()"
            @blur="$v.form.data.$touch()"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="data_menu"
          no-title
          type="month"
          :max="TODAY"
          @input="menu = false"
        ></v-date-picker>
      </v-menu>

      <v-file-input
        v-model="form.input_file"
        label="Selecione o Arquivo"
        truncate-length="35"
        outlined
        append-icon="mdi-upload-outline"
        prepend-icon=""
        :error-messages="inputFileErrors"
        @input="$v.form.input_file.$touch()"
        @blur="$v.form.input_file.$touch()"
      ></v-file-input>
    </SysDialog>

    <DialogDadosTemporariosPlanilha
      :ativar="dialog_fullscreen.ativar"
      :dados="dialog_fullscreen.dados"
      :form="form"
      @fechar-dialog="dialog_fullscreen.ativar = false; $emit('atualizar-produtos-analise-mercado')"
    />
  </div>
</template>

<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import ImportAPI from "../../../api/imports";
import SysDialog from '../../padraoDeLayout/SysDialog.vue';
import SysGrupoAutocomplete from '../../utils/crud/SysGrupoAutocomplete.vue';
import DialogDadosTemporariosPlanilha from "./DialogDadosTemporariosPlanilha.vue";
import $axios from '@/api/api.js'

export default {
  components: {
    SysDialog,
    SysGrupoAutocomplete,
    DialogDadosTemporariosPlanilha
  },
  data() {
    return {
      message: '',
      menu: false,
      data_menu: '',
      ativar_dialog: false,
      dialog_fullscreen: {
        ativar: false,
        dados: []
      },
      form: {
        id_grupo: '',
        input_file: null,
        data: ''
      }
    }
  },

  validations: {
    form: {
      id_grupo: {
        required
      },
      input_file: {
        required
      },
      data: {
        required
      }
    }
  },

  computed: {
    TITULO_IMPORTACAO() {
      return 'Importar Dados da Planilha';
    },

    TODAY() {
      return moment().toISOString();
    },

    idGrupoErrors() {
      const errors = [];
      if (!this.$v.form.id_grupo.$dirty) return errors;
      !this.$v.form.id_grupo.required && errors.push("Preencha com um grupo!");
      return errors;
    },

    dataErrors() {
      const errors = [];
      if (!this.$v.form.data.$dirty) return errors;
      !this.$v.form.data.required && errors.push("O mês/ano de referencia é invalido!");
      return errors;
    },

    inputFileErrors() {
      const errors = [];
      if (!this.$v.form.input_file.$dirty) return errors;
      !this.$v.form.input_file.required && errors.push("Preencha com um arquivo valido!");
      return errors;
    },
  },

  watch: {
    data_menu (val) {
      this.form.data = this.formatDate(this.data_menu)
    },
  },

  methods: {
    baixarModeloPlanilha() {
      window.open($axios.defaults.baseURL + '/download-modelo-planilha-close-up', "_blank");
    },
    formatDate (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${year}`
    },

    abrirDialogImportacao() {
      this.message = '';
      this.form.id_grupo = '';
      this.form.input_file = null;
      this.data_menu = '';
      this.form.data = '';
      this.ativar_dialog = true;
    },

    fecharDialogImportacao() {
      this.$v.$reset();
      this.ativar_dialog = false;
    },

    importarDadosTemporarioPlanilha() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      const token = localStorage.getItem("token");
      const headers = {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }

      const params = new FormData();
      params.append('id_grupo', this.form.id_grupo);
      params.append('data', this.form.data);
      params.append('input_file', this.form.input_file);

      this.$store.dispatch("loadingAux/habilitarLoading", true);

      ImportAPI.importarDadosTemporarioPlanilha(headers, params)
        .then((response) => {
          const { message, dados, token } = response.data;
          localStorage.setItem("token", token);

          if (message) {
            this.message = message;
            return ;
          }

          this.fecharDialogImportacao();
          this.dialog_fullscreen.dados = dados;
          this.dialog_fullscreen.ativar = true;
        })
        .catch(() => {
          this.Helpers.logout();
        })
        .finally(() => this.$store.dispatch("loadingAux/habilitarLoading", false) );
    }
  }
}
</script>

<style>

</style>
